/*!
 * ==========================================================
 * DIGI CLUB HERO
 * Versão: 1.0.0
 *
 * Responsabilidade
 * - Reveal
 * - Floating
 * - Mouse Parallax
 * - CTA
 * ==========================================================
 */

(() => {
  "use strict";

  class DigiClubHero {

    constructor(section) {

      this.section = section;

      this.content = section.querySelectorAll("[data-digi-club-hero-reveal]");

      this.media = section.querySelector("[data-digi-club-hero-media]");

      this.image = section.querySelector(".digi-club-hero__image");

      this.button = section.querySelector("[data-digi-club-hero-modal-trigger]");

      this.animations =
        section.dataset.animations === "true";

      this.motionReduced =
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      this.intensity =
        section.dataset.animationIntensity || "moderate";

      this.mouseX = 0;
      this.mouseY = 0;

      this.imageX = 0;
      this.imageY = 0;

      this.raf = null;

      this.init();

    }

    /* =====================================================
       INIT
    ====================================================== */

    init(){

      this.initReveal();

      this.initCTA();

      this.initParallax();

    }

    /* =====================================================
       REVEAL
    ====================================================== */

    initReveal(){

      if(!this.animations) return;

      if(this.motionReduced){

        this.content.forEach(element=>{
          element.classList.add("is-visible");
        });

        return;

      }

      const observer = new IntersectionObserver(entries=>{

        entries.forEach(entry=>{

          if(!entry.isIntersecting) return;

          entry.target.classList.add("is-visible");

          observer.unobserve(entry.target);

        });

      },{
        threshold:.15
      });

      this.content.forEach(element=>{

        observer.observe(element);

      });

    }

    /* =====================================================
       CTA
    ====================================================== */

    initCTA(){

      if(!this.button) return;

      this.button.addEventListener("click",()=>{

        this.section.dispatchEvent(
          new CustomEvent(
            "digi-club:hero:cta",
            {
              bubbles:true
            }
          )
        );

        const selector =
          this.section.dataset.modalSelector;

        if(!selector) return;

        const modalTrigger =
          document.querySelector(selector);

        if(!modalTrigger) return;

        modalTrigger.click();

      });

    }

    /* =====================================================
       PARALLAX
    ====================================================== */

    initParallax(){

      if(!this.media) return;

      if(!this.image) return;

      if(this.motionReduced) return;

      if(window.innerWidth < 992) return;

      this.media.addEventListener(
        "mousemove",
        this.onMouseMove.bind(this)
      );

      this.media.addEventListener(
        "mouseleave",
        this.onMouseLeave.bind(this)
      );

      this.animate();

    }

    onMouseMove(event){

      const rect =
        this.media.getBoundingClientRect();

      const x =
        event.clientX - rect.left;

      const y =
        event.clientY - rect.top;

      this.mouseX =
        (x / rect.width -.5);

      this.mouseY =
        (y / rect.height -.5);

    }

    onMouseLeave(){

      this.mouseX = 0;

      this.mouseY = 0;

    }

    animate(){

      this.imageX +=
        ((this.mouseX * this.getStrength()) - this.imageX) * .08;

      this.imageY +=
        ((this.mouseY * this.getStrength()) - this.imageY) * .08;

      this.image.style.transform =
        `translate3d(${this.imageX}px,${this.imageY}px,0)`;

      this.raf =
        requestAnimationFrame(
          this.animate.bind(this)
        );

    }

    getStrength(){

      switch(this.intensity){

        case "strong":
          return 18;

        case "subtle":
          return 6;

        default:
          return 10;

      }

    }

  }

  document.addEventListener("DOMContentLoaded",()=>{

    document
      .querySelectorAll("[data-digi-club-hero]")
      .forEach(section=>{

        new DigiClubHero(section);

      });

  });

})();